export default function Security() {
  const securityFeatures = [
    'AES-256 Military-Grade Encryption',
    'OpenVPN & WireGuard Protocols',
    'Perfect Forward Secrecy',
    'Secure Core Architecture',
    'No IP/DNS Leaks',
    'Automatic Kill Switch'
  ];

  return (
    <section id="security" className="bg-gray-900 py-36">
      <div className="max-w-7xl mx-auto px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-20 items-center">
          <div className="lg:col-span-2">
            <div className="w-16 h-1 bg-cyan-500 mb-8"></div>
            <h2 className="text-6xl font-bold text-white mb-8 leading-tight">
              Military-Grade Security
            </h2>
            <p className="text-lg text-gray-300 leading-relaxed mb-10">
              We use the same encryption standards trusted by governments and military organizations worldwide. Your data is protected by AES-256 encryption, making it virtually impossible for anyone to intercept or decrypt your online activities.
            </p>

            <div className="space-y-5">
              {securityFeatures.map((feature, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-2xl text-cyan-500"></i>
                  </div>
                  <span className="text-base text-gray-200">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 relative">
            <div className="relative w-full h-[600px]">
              <img
                src="https://public.readdy.ai/ai/img_res/0f5b029fe55e94acda4b0963b9813d0e.jpg"
                alt="Security Encryption"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
